const customScrollTop = () => {
  if (import.meta.browser && window) {
    window.scrollTo(0, 0);
  }
};

const scrollToTopSmooth = () => {
  if (import.meta.browser && window) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
};

export const useCustomScroll = () => {
  return {
    customScrollTop,
    scrollToTopSmooth,
  };
};
